module.exports = __webpack_public_path__ + "img/language.8e1788a4.svg";